var e = require("@inertiajs/inertia"),
  t = {
    functional: !0,
    props: {
      data: {
        type: Object,
        default: function () {
          return {};
        }
      },
      href: {
        type: String,
        required: !0
      },
      method: {
        type: String,
        default: "get"
      },
      replace: {
        type: Boolean,
        default: !1
      },
      preserveScroll: {
        type: Boolean,
        default: !1
      },
      preserveState: {
        type: Boolean,
        default: !1
      },
      only: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    render: function (t, r) {
      var n = r.props,
        o = r.data,
        i = r.children;
      return t("a", Object.assign({}, o, {
        attrs: Object.assign({}, o.attrs, {
          href: n.href
        }),
        on: Object.assign({}, o.on || {}, {
          click: function (t) {
            o.on && o.on.click && o.on.click(t), e.shouldIntercept(t) && (t.preventDefault(), e.Inertia.visit(n.href, {
              data: n.data,
              method: n.method,
              replace: n.replace,
              preserveScroll: n.preserveScroll,
              preserveState: n.preserveState,
              only: n.only
            }));
          }
        })
      }), i);
    }
  },
  r = {
    created: function () {
      var t = this;
      if (this.$options.remember) {
        Array.isArray(this.$options.remember) && (this.$options.remember = {
          data: this.$options.remember
        }), "string" == typeof this.$options.remember && (this.$options.remember = {
          data: [this.$options.remember]
        }), "string" == typeof this.$options.remember.data && (this.$options.remember = {
          data: [this.$options.remember.data]
        });
        var r = this.$options.remember.key instanceof Function ? this.$options.remember.key() : this.$options.remember.key,
          n = e.Inertia.restore(r);
        this.$options.remember.data.forEach(function (o) {
          void 0 !== n && void 0 !== n[o] && (t[o] = n[o]), t.$watch(o, function () {
            e.Inertia.remember(t.$options.remember.data.reduce(function (e, r) {
              var n;
              return Object.assign({}, e, ((n = {})[r] = t[r], n));
            }, {}), r);
          }, {
            immediate: !0,
            deep: !0
          });
        });
      }
    }
  },
  n = {},
  o = {
    name: "Inertia",
    props: {
      initialPage: {
        type: Object,
        required: !0
      },
      resolveComponent: {
        type: Function,
        required: !0
      },
      transformProps: {
        type: Function,
        default: function (e) {
          return e;
        }
      }
    },
    data: function () {
      return {
        component: null,
        props: {},
        key: null
      };
    },
    created: function () {
      var t = this;
      n = this, e.Inertia.init({
        initialPage: this.initialPage,
        resolveComponent: this.resolveComponent,
        updatePage: function (e, r, n) {
          var o = n.preserveState;
          t.component = e, t.props = t.transformProps(r), t.key = o ? t.key : Date.now();
        }
      });
    },
    render: function (e) {
      if (this.component) {
        var t = e(this.component, {
          key: this.key,
          props: this.props
        });
        return this.component.layout ? "function" == typeof this.component.layout ? this.component.layout(e, t) : e(this.component.layout, [t]) : t;
      }
    },
    install: function (o) {
      Object.defineProperty(o.prototype, "$inertia", {
        get: function () {
          return e.Inertia;
        }
      }), Object.defineProperty(o.prototype, "$page", {
        get: function () {
          return n.props;
        }
      }), o.mixin(r), o.component("InertiaLink", t);
    }
  };
exports.InertiaApp = o, exports.InertiaLink = t;